import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthContext.jsx";
import { CartProvider } from "@/cart/CartContext.jsx";
import { FavoritesProvider } from "@/favorites/FavoritesContext.jsx";
import { StoreInfoProvider } from "@/store/StoreInfoContext.jsx";
import StoreDocumentTitle from "@/components/StoreDocumentTitle.jsx";
import { FavoritesFeedbackToast } from "@/components/FavoriteHeartButton.jsx";
import ScrollToTop from "@/components/ScrollToTop.jsx";
import AppRouter from "./AppRouter.jsx";

export function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <CartProvider>
                    <FavoritesProvider>
                        <StoreInfoProvider>
                            <ScrollToTop />
                            <StoreDocumentTitle />
                            <AppRouter />
                            <FavoritesFeedbackToast />
                        </StoreInfoProvider>
                    </FavoritesProvider>
                </CartProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
